import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import { FormattedMessage } from 'react-intl';

export default function LoadingErrorState() {
    return <ErrorState headline={<FormattedMessage id={'marketplace.error.loading'} />} />;
}
